// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { TimeDataUpdateUpload } from '@/costs/components/time-data-update-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export function TimeDataUpdateDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Update time data</DialogTitle>
      <DialogContent dividers>
        <TimeDataUpdateUpload
          onClose={props.onClose}
          onSuccess={props.onSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}
